import React from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';

function renderInput(inputProps) {
    const { InputProps, label, placeholder, classes, ref, ...other } = inputProps;

    return (
        <TextField
            InputProps={{
                inputRef: ref,
                classes: {
                    root: classes.inputRoot,
                },
                ...InputProps,
            }}
            label={label}
            {...other}
        />
    );
}




class InputSeletorPerfil extends React.Component {


    constructor(props) {
        super(props);
        this.state = { texto: "" }
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }
    onChangeTexto(texto) {
        this.setState({ texto })
    }

    handleKeyDown(event) {//Remover selecionados com backspace
        // console.log("handleKeyDown");

        // let itens = []
        // if (this.props.input.value) {
        //     itens = this.props.input.value.slice()
        // }
        // if (itens.length && !this.state.texto.length && keycode(event) === 'backspace') {
        //     this.onChangeState(itens.slice(0, itens.length - 1))
        // }
    };

    handleInputChange(event) {
        this.setState({ texto: event.target.value })
    };

    handleChange(email) {
        const { perfis, input: { value, onChange } } = this.props
        let perfil = null;
        perfis.forEach(p => {
            if (p.email === email)
                perfil = p;
        });
        if (!perfil) {
            return;
        }
        let newValue = { ...value }
        newValue[perfil.uid] = true
        this.setState({ texto: "" })
        onChange(newValue)
    };

    handleDelete(uid) {
        return () => {

            const { input: { value, onChange } } = this.props
            let newValue = { ...value }

            newValue[uid] = false
            onChange(newValue)

        };
    }

    getSuggestions(inputValue) {
        if (!inputValue || inputValue.length < 3) {
            return []
        }
        const { perfis } = this.props
        let count = 0;
        let suggestions = perfis.filter(function (el) {
            return el != null;
        })

        return suggestions.filter(perfil => {
            const keep = (!inputValue || perfil.email.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) &&
                count < 5;

            if (keep) {
                count += 1;
            }

            return keep;
        });
    }


    renderSuggestion({ perfil, index, itemProps, highlightedIndex, selectedItem }) {
        const isHighlighted = highlightedIndex === index;

        return (
            <MenuItem
                {...itemProps}
                key={perfil.email}
                selected={isHighlighted}
                component="div"
                style={{
                    fontWeight: 400,
                }}
            >
                {perfil.email}
            </MenuItem>
        );
    }
    renderSelecionados(value) {
        const { perfis, classes } = this.props

        let comps = []

        for (let uid in value) {
            if (value[uid]) {


                let perfil = null;

                perfis.forEach(p => {
                    if (p.uid === uid)
                        perfil = p;
                });
                if (perfil) {
                    comps.push(<Chip
                        key={uid}
                        tabIndex={-1}
                        label={perfil.email}
                        className={classes.chip}
                        onDelete={this.handleDelete(uid)}
                    />)
                }
            }
        }

        return comps;
    }

    render() {
        const { classes, label, placeholder, input: { value } } = this.props;

        return (
            <Downshift inputValue={this.state.texto} onChange={this.handleChange} selectedItem={value}>
                {({
                    getInputProps,
                    getItemProps,
                    isOpen,
                    inputValue: inputValue2,
                    selectedItem: itens,
                    highlightedIndex,
                }) => (
                        <div className={classes.container}>
                            {renderInput({
                                fullWidth: true,
                                classes,
                                label,
                                placeholder,
                                InputProps: getInputProps({
                                    startAdornment: this.renderSelecionados(value),
                                    onChange: this.handleInputChange,
                                    onKeyDown: this.handleKeyDown,
                                    placeholder,
                                    id: 'integration-downshift-multiple',
                                }),
                            })}
                            {isOpen ? (
                                <Paper className={classes.paper} square>
                                    {this.getSuggestions(inputValue2).map((perfil, index) =>
                                        this.renderSuggestion({
                                            perfil,
                                            index,
                                            itemProps: getItemProps({ item: perfil.email }),
                                            highlightedIndex,
                                            selectedItem: itens,
                                        }),
                                    )}
                                </Paper>
                            ) : null}
                        </div>
                    )}
            </Downshift>
        );
    }
}

InputSeletorPerfil.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles = theme => ({
    root: {
        flexGrow: 1,
        height: 250,
    },
    container: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    inputRoot: {
        flexWrap: 'wrap',
    },
});


InputSeletorPerfil = withStyles(styles)(InputSeletorPerfil);

export default InputSeletorPerfil;



// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/componentes/ConvidarPerfil/components/SeletorPerfil/InputSeletorPerfil.js